/**
 * ThemeProvider (M10, RF-M10-006 / RN-M10-002 / ADR-016) — carrega o white-label
 * via `GET /config` no boot e o aplica através do WhiteLabelContext (nome, cor,
 * logo). Enquanto a config não chega (ou em falha), usa o default neutro — o
 * boot NUNCA quebra por white-label indisponível.
 *
 * Deve ficar DENTRO do ServicesProvider (usa o painelApi) e ENVOLVER o AppShell,
 * para que o cabeçalho reflita a cor/nome sem rebuild (Req 6 AC3).
 */

import { ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useServices } from '../contexts/ServicesContext';
import {
  DEFAULT_WHITE_LABEL,
  WhiteLabelConfig,
  WhiteLabelContext,
} from '../contexts/WhiteLabelContext';

/** Converte a resposta do contrato (ConfigWhiteLabel) no shape do contexto. */
function paraContexto(config: {
  nomeSistema: string;
  corPrimaria: string;
  logoUrl: string;
}): WhiteLabelConfig {
  return {
    systemName: config.nomeSistema || DEFAULT_WHITE_LABEL.systemName,
    primaryColor: config.corPrimaria || DEFAULT_WHITE_LABEL.primaryColor,
    logoUrl: config.logoUrl && config.logoUrl.length > 0 ? config.logoUrl : null,
  };
}

export function ThemeProvider({ children }: { children: ReactNode }): JSX.Element {
  const { painel } = useServices();
  const query = useQuery({
    queryKey: ['config'],
    queryFn: () => painel.obterConfig(),
    // Falha de config não deve quebrar o boot — cai no default.
    retry: 1,
  });

  const value: WhiteLabelConfig = query.data ? paraContexto(query.data) : DEFAULT_WHITE_LABEL;

  return <WhiteLabelContext.Provider value={value}>{children}</WhiteLabelContext.Provider>;
}
